import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import ScrollToTop from 'components/ScrollToTop';
import ErrorBoundary from 'components/ErrorBoundary';
import NotFound from 'pages/NotFound';
import ServiceManagement from './pages/service-management';
import ProviderManagement from './pages/Provider-management';
import EmployeeManagement from './pages/employee-management';
import ProviderDashboard from './pages/Provider-dashboard';
import AvailabilityCalendar from './pages/availability-calendar';
import UserProfile from './pages/user-profile';
import LoginIndex from 'pages/Auth/Index';
import PrivateRoute from 'PrivateRoutes';
import BodyFatCalculator from 'pages/test';
import GlobalClients from 'pages/global-clients';
import AIManagement from 'pages/ai-management';
import AssessmentManagement from 'pages/assessment-management';
import SinohehReferrals from 'pages/sinoheh-referrals';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public Route */}
          <Route path="/" element={<LoginIndex />} />
          {/* Protected Routes */}
          <Route
            path="/service-management"
            element={
              <PrivateRoute>
                <ServiceManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/test"
            element={
              <PrivateRoute>
                <BodyFatCalculator />
              </PrivateRoute>
            }
          />
          <Route
            path="/provider-management"
            element={
              <PrivateRoute>
                <ProviderManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/employee-management"
            element={
              <PrivateRoute>
                <EmployeeManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/provider-dashboard"
            element={
              <PrivateRoute>
                <ProviderDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/all-clients"
            element={
              <PrivateRoute>
                <GlobalClients />
              </PrivateRoute>
            }
          />
          <Route
            path="/ai-management"
            element={
              <PrivateRoute>
                <AIManagement />
              </PrivateRoute>
            }
          />

          <Route
            path="/sinoheh-referrals"
            element={
              <PrivateRoute>
                <SinohehReferrals />
              </PrivateRoute>
            }
          />

          <Route
            path="/availability-calendar"
            element={
              <PrivateRoute>
                <AvailabilityCalendar />
              </PrivateRoute>
            }
          />
          <Route
            path="/user-profile"
            element={
              <PrivateRoute>
                <UserProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="/assessments"
            element={
              <PrivateRoute>
                <AssessmentManagement />
              </PrivateRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
